import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.admin');
import { OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.admin/view.scss */
:host {
  --admin-canvas: #f4f6f8;
  --admin-surface: #ffffff;
  --admin-surface-subtle: #f8fafc;
  --admin-border: #dce2ea;
  --admin-border-soft: #edf1f5;
  --admin-text-strong: #111827;
  --admin-text: #334155;
  --admin-text-muted: #64748b;
  --admin-text-faint: #94a3b8;
  --admin-primary: #4f46e5;
  --admin-primary-dark: #3730a3;
  --admin-primary-soft: #eef2ff;
  --admin-success: #047857;
  --admin-success-soft: #ecfdf5;
  --admin-warning: #b45309;
  --admin-warning-soft: #fffbeb;
  --admin-danger: #be123c;
  --admin-danger-soft: #fff1f2;
  --admin-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 26px rgba(15, 23, 42, 0.04);
  --admin-shadow-raised: 0 12px 30px rgba(15, 23, 42, 0.08);
  display: block;
  height: 100%;
  min-height: 100vh;
}

.admin-shell {
  min-height: 100vh;
  background: var(--admin-canvas);
  color: var(--admin-text-strong);
}

.admin-mobilebar {
  display: none;
}

.admin-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 40;
  display: flex;
  width: 14rem;
  height: 100vh;
  flex-direction: column;
  border-right: 1px solid var(--admin-border);
  background: var(--admin-surface);
  box-shadow: 4px 0 18px rgba(15, 23, 42, 0.025);
}

.admin-brand {
  display: flex;
  min-height: 68px;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  border-bottom: 1px solid var(--admin-border-soft);
}

.admin-brand strong {
  color: var(--admin-text-strong);
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.admin-brand span {
  margin-top: 2px;
  color: var(--admin-text-muted);
  font-size: 11px;
}

.admin-navigation {
  flex: 1;
  overflow: auto;
  padding: 12px;
}

.admin-nav-link {
  position: relative;
  display: flex;
  min-height: 40px;
  align-items: center;
  margin-bottom: 3px;
  padding: 0 12px;
  border-radius: 8px;
  color: var(--admin-text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.admin-nav-link:hover {
  background: var(--admin-surface-subtle);
  color: var(--admin-text-strong);
}

.admin-nav-link.is-active {
  background: var(--admin-primary-soft);
  box-shadow: inset 0 0 0 1px #c7d2fe;
  color: var(--admin-primary-dark);
  font-weight: 750;
}

.admin-account {
  padding: 12px;
  border-top: 1px solid var(--admin-border-soft);
}

.admin-account__email {
  overflow: hidden;
  padding: 0 8px 8px;
  color: var(--admin-text-muted);
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-account button {
  width: 100%;
  min-height: 36px;
  padding: 0 8px;
  border-radius: 7px;
  color: var(--admin-text-muted);
  font-size: 12px;
  text-align: left;
}

.admin-account button:hover {
  background: var(--admin-surface-subtle);
  color: var(--admin-text-strong);
}

.admin-content {
  min-width: 0;
  padding-left: 14rem;
}

.admin-content__scroll {
  min-height: 100vh;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.36) 0, rgba(255, 255, 255, 0) 190px), var(--admin-canvas);
}

.admin-loading {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
}

.admin-nav-backdrop {
  display: none;
}

@media (max-width: 767px) {
  .admin-mobilebar {
    position: fixed;
    inset: 0 0 auto;
    z-index: 30;
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-bottom: 1px solid var(--admin-border);
    background: rgba(255, 255, 255, 0.96);
  }
  .admin-mobilebar strong {
    overflow: hidden;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .admin-menu-button {
    display: inline-flex;
    width: 36px;
    height: 36px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--admin-border);
    border-radius: 8px;
    background: var(--admin-surface);
    color: var(--admin-text);
  }
  .admin-nav-backdrop {
    position: fixed;
    inset: 0;
    z-index: 35;
    display: block;
    background: rgba(15, 23, 42, 0.35);
  }
  .admin-sidebar {
    width: min(17rem, 86vw);
    transform: translateX(-100%);
    transition: transform 180ms ease;
  }
  .admin-sidebar.is-open {
    transform: translateX(0);
  }
  .admin-content {
    padding-top: 56px;
    padding-left: 0;
  }
}`],
})
export class LayoutAdminComponent implements OnInit {
    public session: any = {};
    public mobileNavOpen: boolean = false;
    public menus: any[] = [
        { path: '/admin/dashboard', label: '대시보드', icon: 'chart' },
        { path: '/admin/subjects',  label: '대상자 관리', icon: 'users' },
        { path: '/admin/statistics', label: '설문 통계', icon: 'stats' },
        { path: '/admin/results',   label: '검사·설문 결과', icon: 'doc' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                    const container = document.querySelector('.admin-content__scroll') as HTMLElement | null;
                    if (container) container.scrollTop = 0;
                });
            }
        });
        try {
            let { code, data } = await wiz.call("session");
            if (code === 200) {
                this.session = this.payload(data);
                if (this.session.must_change_pw) {
                    await this.promptChangePassword();
                }
            } else {
                location.href = "/login";
                return;
            }
        } catch (e) {
            location.href = "/login";
            return;
        }
        await this.service.render();
    }

    public isActive(path: string): boolean {
        try {
            return this.router.url.indexOf(path) === 0;
        } catch {
            return false;
        }
    }

    public currentMenuLabel(): string {
        const active = this.menus.find((menu: any) => this.isActive(menu.path));
        return active?.label || '관리자';
    }

    public async toggleMobileNav() {
        this.mobileNavOpen = !this.mobileNavOpen;
        await this.service.render();
    }

    public async closeMobileNav() {
        this.mobileNavOpen = false;
        await this.service.render();
    }

    public async logout() {
        this.mobileNavOpen = false;
        await wiz.call("logout");
        location.href = "/login";
    }

    public async promptChangePassword() {
        const np = prompt("초기 비밀번호 변경이 필요합니다. 새 비밀번호를 입력하세요. (최소 8자)");
        if (!np || np.length < 8) {
            alert("비밀번호는 최소 8자 이상이어야 합니다. 로그아웃합니다.");
            await this.logout();
            return;
        }
        const np2 = prompt("새 비밀번호를 한 번 더 입력하세요.");
        if (np !== np2) {
            alert("비밀번호가 일치하지 않습니다. 다시 시도해주세요.");
            return this.promptChangePassword();
        }
        const { code, data } = await wiz.call("change_password", { new_password: np });
        if (code === 200) {
            alert("비밀번호가 변경되었습니다.");
            this.session.must_change_pw = 0;
        } else {
            alert((data && data.message) || "비밀번호 변경에 실패했습니다.");
            await this.logout();
        }
    }
}

export default LayoutAdminComponent;